import React, { useState } from 'react';
import { getBrandImage } from '../../data/brandImages';
import { NAV_ITEMS, MEMBER_NAV_ITEMS, DEFAULT_SITE_CONTACT } from '../../data/siteContent';

const Crown = ({ className = 'w-8 h-8' }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <path d="M8 34h32L36 18l-8 8-4-14-4 14-8-8L8 34z" fill="#F2C94C" />
    <path d="M8 34h32v4H8v-4z" fill="#E0B63A" />
  </svg>
);

export const ClientHeader = ({
  currentView,
  setCurrentView,
  userProfile,
  loggedInUser,
  onLogout,
  siteConfig,
}) => {
  const [open, setOpen] = useState(false);
  const logo = getBrandImage(siteConfig, 'logo');
  const isLogged = loggedInUser?.rol === 'cliente';
  const menuItems = isLogged ? MEMBER_NAV_ITEMS : NAV_ITEMS;

  const go = (view) => {
    setCurrentView(view);
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between h-[76px] gap-3">
          <button onClick={() => go('home')} className="flex items-center shrink-0">
            <img src={logo} alt="Maja Morena" className="h-14 w-14 object-contain" />
          </button>

          <nav className="hidden lg:flex items-center gap-6 absolute left-1/2 -translate-x-1/2">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => go(item.id)}
                className={`text-sm font-extrabold pb-1 border-b-2 ${
                  currentView === item.id
                    ? 'text-maja-red border-maja-red'
                    : 'text-gray-700 border-transparent hover:text-maja-red'
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2">
            {isLogged ? (
              <>
                <button onClick={() => go('history')} className="px-3 text-right">
                  <p className="text-[10px] uppercase tracking-wide text-gray-400 leading-none">Puntos</p>
                  <p className="text-sm font-black text-maja-red leading-tight">
                    {(userProfile?.puntos || 0).toLocaleString('es-AR')}
                  </p>
                </button>
                <button
                  onClick={() => go('profile')}
                  className={`h-10 px-4 rounded-full border text-sm font-extrabold ${
                    currentView === 'profile'
                      ? 'border-maja-red text-maja-red bg-red-50'
                      : 'border-gray-200 text-gray-700'
                  }`}
                >
                  Mi cuenta
                </button>
                <button onClick={onLogout} className="h-10 px-3 text-sm font-extrabold text-gray-400 hover:text-maja-red">
                  Salir
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => go('login')}
                  className="h-10 px-4 rounded-full border border-gray-200 text-sm font-extrabold text-gray-800"
                >
                  Iniciar sesión
                </button>
                <button
                  onClick={() => go('registration')}
                  className="h-10 px-5 rounded-full bg-maja-red text-white text-sm font-extrabold"
                >
                  Quiero sumarme
                </button>
              </>
            )}
          </div>

          {isLogged && (
            <button onClick={() => go('history')} className="md:hidden text-right mr-1">
              <p className="text-[10px] uppercase tracking-wide text-gray-400 leading-none">Puntos</p>
              <p className="text-sm font-black text-maja-red leading-tight">
                {(userProfile?.puntos || 0).toLocaleString('es-AR')}
              </p>
            </button>
          )}
          <button className="lg:hidden p-2" onClick={() => setOpen((v) => !v)} aria-label="Abrir menú">
            <span className="block w-5 h-0.5 bg-gray-800 mb-1.5" />
            <span className="block w-5 h-0.5 bg-gray-800 mb-1.5" />
            <span className="block w-4 h-0.5 bg-gray-800" />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-100 px-4 py-3 space-y-1 bg-white">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => go(item.id)}
              className={`block w-full text-left px-3 py-3 rounded-xl font-extrabold ${
                currentView === item.id ? 'text-maja-red bg-red-50' : 'text-gray-800'
              }`}
            >
              {item.label}
            </button>
          ))}
          {isLogged ? (
            <>
              <button onClick={() => go('profile')} className="block w-full text-left px-3 py-3 font-extrabold">Mi cuenta</button>
              <button onClick={() => { setOpen(false); onLogout(); }} className="block w-full text-left px-3 py-3 font-extrabold text-maja-red">Salir</button>
            </>
          ) : (
            <>
              <button onClick={() => go('login')} className="block w-full text-left px-3 py-3 font-extrabold">Iniciar sesión</button>
              <button onClick={() => go('registration')} className="block w-full text-left px-3 py-3 font-extrabold text-maja-red">Quiero sumarme</button>
            </>
          )}
        </div>
      )}
    </header>
  );
};

export const BrandStrip = ({ setCurrentView, title, cta = 'Conocer beneficios', target = 'benefits' }) => (
  <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4">
    <div className="rounded-2xl bg-maja-red text-white px-6 py-5 md:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <Crown className="w-8 h-8" />
        <div>
          <p className="font-display font-black text-xl leading-none uppercase tracking-tight">Maja Club</p>
          <p className="text-sm text-white/90 mt-1">{title}</p>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <button
          onClick={() => setCurrentView(target)}
          className="h-10 px-5 rounded-full bg-white text-maja-red font-extrabold text-sm"
        >
          {cta} →
        </button>
        <p className="font-script text-2xl hidden md:block">Un gran sabor en cada momento</p>
      </div>
    </div>
  </div>
);

export const ClientFooter = ({ setCurrentView, siteConfig }) => {
  const contact = { ...DEFAULT_SITE_CONTACT, ...(siteConfig?.contacto || {}) };
  return (
    <footer className="mt-6 footer-doodle text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid md:grid-cols-3 gap-6 items-center">
        <p className="font-script text-3xl md:text-4xl leading-tight">Hacemos tu vida más rica</p>
        <div className="flex flex-wrap justify-center items-center gap-4 text-sm font-extrabold">
          <span className="opacity-80">Seguinos</span>
          <a href={contact.instagram} target="_blank" rel="noreferrer" className="hover:opacity-80">Instagram</a>
          <a href={contact.facebook} target="_blank" rel="noreferrer" className="hover:opacity-80">Facebook</a>
          <a href={contact.tiktok} target="_blank" rel="noreferrer" className="hover:opacity-80">TikTok</a>
          <a href={contact.youtube} target="_blank" rel="noreferrer" className="hover:opacity-80">YouTube</a>
        </div>
        <p className="font-script text-2xl md:text-3xl text-right hidden md:block">La buena comida siempre une</p>
      </div>
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 py-3 flex justify-center">
          <a
            href="https://maja-morena-ops.web.app"
            target="_blank"
            rel="noreferrer"
            className="text-xs tracking-[0.18em] uppercase text-white/40 hover:text-white/70"
          >
            Ingreso de personal →
          </a>
        </div>
      </div>
    </footer>
  );
};

const ClientLayout = ({ children, ...headerProps }) => (
  <div className="min-h-screen bg-white text-gray-900 font-sans flex flex-col">
    <ClientHeader {...headerProps} />
    <main className="flex-1">{children}</main>
    <ClientFooter setCurrentView={headerProps.setCurrentView} siteConfig={headerProps.siteConfig} />
  </div>
);

export default ClientLayout;
export { Crown };
